export const SET_MIN_TIME_VALIDATE = 'Page/SET_MIN_TIME_VALIDATE';
export const SET_MAX_TIME_VALIDATE = 'Page/SET_MAX_TIME_VALIDATE';
export const SET_VALIDATE = 'Page/SET_VALIDATE';